import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSliderModule } from '@angular/material/slider';
import { MatButtonModule } from '@angular/material/button';

import { ViewerComponent } from './components/viewer/viewer.component';
import { ShapeClickDirective } from './directives/shape-click.directive';
import { PanDirective } from './directives/pan.directive';
import { MouseWheelDirective } from './directives/mouse-wheel.directive';



@NgModule({
  declarations: [ViewerComponent, ShapeClickDirective, PanDirective, MouseWheelDirective],
  imports: [
    CommonModule,
    MatSliderModule,
    MatButtonModule
  ],
  exports: [ViewerComponent]
})
export class AckSvgViewerModule { }
